/**
 * Minutes on a timed thing (a task, or a bare logged/running pair) = closed
 * labour + the live span if it is running right now.
 *
 * Collapsed here from four independent copies of the same formula
 * (`logged + Math.floor((now - runningSince) / 60_000)`) that had drifted
 * apart across the WO detail tree (`woDetail.ts`), the Today feed
 * (`TodayRoute.tsx`), the bottom action bar (`BottomActionBar.tsx`), and
 * the optimistic pause patch (`useWorkshop.ts`'s `bankedMinutes`) — one
 * formula, and it is the shared `elapsedMinutes`'s job now, not this
 * file's.
 */
import { elapsedMinutes } from '@vollgas/shared/utils'

/** The minimal shape every "is this thing timing right now" caller has. */
export interface TimedMinutes {
  readonly loggedMinutes: number
  readonly runningSince: string | null
}

export function taskMinutes(entry: TimedMinutes, now: number): number {
  return entry.loggedMinutes + elapsedMinutes(entry.runningSince, now)
}
